module.exports = __webpack_public_path__ + "img/visa.32f6b8a4.svg";